import React, {
  useState,
  createContext,
  useContext,
  ReactNode,
  FormEvent,
} from 'react';
import PropTypes from 'prop-types';

interface InfoContextProps {
  data: any;
  updateInfo: any;
  updateAccentColor: any;
  updateSocialColor: any;
}

interface InfoProviderProps {
  children: ReactNode;
}

export const InfoContext = createContext<Partial<InfoContextProps>>({});

export const InfoProvider = ({ children }: InfoProviderProps) => {
  const [state, setState] = useState({
    portrait: '',
    logo: '',
    firstName: '',
    lastName: '',
    jobTitle: '',
    department: '',
    companyName: '',
    officePhone: '',
    mobilePhone: '',
    websiteUrl: '',
    emailAddress: '',
    address: '',
    socialLinkedin: '',
    socialFacebook: '',
    socialTwitter: '',
    socialInstagram: '',
    accentColor: '#000',
    socialColor: '#000',
  });
  return (
    <InfoContext.Provider
      value={{
        data: state,
        updateInfo: (e: FormEvent<HTMLInputElement>) => {
          setState({
            ...state,
            [e.currentTarget.name]: e.currentTarget.value,
          });
        },
        updateAccentColor: (color: string) => {
          setState({
            ...state,
            accentColor: color,
          });
        },
        updateSocialColor: (color: string) => {
          setState({
            ...state,
            socialColor: color,
          });
        },
      }}
    >
      {children}
    </InfoContext.Provider>
  );
};

export const useInfoValue = () => useContext(InfoContext);

export const JobTitle = () => {
  const { data } = useInfoValue();
  return (
    <p
      color="#808080"
      style={{
        fontSize: '12px',
        margin: '5px 0',
        padding: '0 0 12px',
        color: '#808080',
      }}
    >
      {' '}
      {data.jobTitle ? data.jobTitle : 'Regional Manager'}
    </p>
  );
};

export const CompanyNames = [
  { id: 0, name: 'Golden State Company' },
  { id: 1, name: 'Moontide' },
  { id: 2, name: 'Emergent' },
  { id: 3, name: 'Ventura Blvd' },
  { id: 4, name: 'Southbay' },
  { id: 5, name: 'Launch CMD' },
];

export const LosAngelesOfficePhone = () => {
  const { data } = useInfoValue();

  const LoasAngelesOfficePhone = data.officePhone
    ? data.officePhone
    : '310.376.7800';

  return (
    <td
      style={{
        fontSize: '11px',
        color: '#808080',
        lineHeight: '15px',
        textDecoration: 'none',
        minWidth: '70px',
      }}
    >
      <span>
        <a
          style={{ textDecoration: 'none', color: '#808080' }}
          href={`tel:${LoasAngelesOfficePhone}`}
        >
          {LoasAngelesOfficePhone}
        </a>
      </span>
    </td>
  );
};

InfoProvider.propTypes = {
  children: PropTypes.node,
};
